import React from 'react';
import { Typography, Alert } from 'antd';
import style from './index.module.css';

const { Title, Paragraph, Text } = Typography;

export default function ArticleSections({ sections = [] }) {
    return (
        <div className={style.sections}>
            {sections.map((section, index) => {
                switch (section.type) {
                    case 'paragraph':
                        return (
                            <Paragraph key={index} className={style.paragraph}>
                                {section.text}
                            </Paragraph>
                        );
                    case 'heading':
                        return (
                            <Title key={index} level={4} className={style.sectionHeading}>
                                {section.text}
                            </Title>
                        );
                    case 'steps':
                        return (
                            <ol key={index} className={style.steps}>
                                {section.items.map((item, i) => (
                                    <li key={i}>
                                        <Text>{item}</Text>
                                    </li>
                                ))}
                            </ol>
                        );
                    case 'note':
                        return (
                            <Alert
                                key={index}
                                type="info"
                                showIcon
                                message={section.text}
                                className={style.note}
                            />
                        );
                    default:
                        return null;
                }
            })}
        </div>
    );
}
